import { Sparkles, Award, BookOpen } from "lucide-react";

export const LifeHeroSection = ({ onStartQuiz }) => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden pt-16 bg-gradient-to-b from-primary via-teal-dark to-teal-dark">
      {/* Mandala Pattern Overlay */}
      <div className="absolute inset-0 mandala-bg opacity-30 z-10" />

      {/* Content */}
      <div className="container relative z-20 text-center px-4 py-8 md:py-12">
        <div className="max-w-4xl mx-auto animate-fade-up">
          {/* Coach Badge */}
          <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6 border border-accent/30">
            <span className="text-sm text-primary-foreground/90">
              By <strong className="text-accent">Vinod Kumar</strong>, Relationship and Life WISDOM Coach
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-primary-foreground mb-6 leading-tight text-balance">
            Discover Your Life's Hidden Potential in{" "}
            <span className="text-gradient-lime">3 Minutes</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-primary-foreground/85 max-w-3xl mx-auto mb-8 leading-relaxed text-balance">
            Take our free diagnostic quiz based on the{" "}
            <strong className="text-accent">Five Koshas</strong> and{" "}
            <strong className="text-accent">Vedantic Wisdom</strong> to uncover 
            your strengths and growth areas across all dimensions of life.
          </p>

          {/* CTA Button */}
          <button
            onClick={onStartQuiz}
            className="btn-lime text-lg md:text-xl px-10 md:px-12 py-4 md:py-5 animate-pulse-lime mb-10"
            data-testid="start-life-quiz-btn"
          >
            Start Free Diagnostic Now
          </button>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-primary-foreground/80">
            <div className="flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">For Professionals & Students</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-primary-foreground/30" />
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">SIWON Framework</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-primary-foreground/30" />
            <div className="flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">Ancient Wisdom Applied</span>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
          <div className="w-6 h-10 rounded-full border-2 border-primary-foreground/40 flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-accent rounded-full animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LifeHeroSection;
